import React from 'react'
import { exportToCSV } from '../../functions'

const PageHeader = ({title, description, exportButton, addButton, data, setShowAdd, addition}) => {
    const addButtonText = addButton === "Add University" ? "Add University" : addButton === "Add Grade" ? "Add Grade" : addButton === "Add Chain" ? "Add Chain" : addButton;
    return (
        <div className="bg-white rounded-xl mb-2 shadow-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                        <p className="text-gray-600 text-sm">{description}</p>
                    </div>
                </div>

                <div className="flex items-center space-x-3">
                    {/* Export Button */}
                    {exportButton && data && data?.length ? (
                        <button
                            className="flex items-center space-x-2 px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all duration-200 shadow-md hover:shadow-lg"
                            onClick={() => {
                                exportToCSV(data, title + " Data");
                            }}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            <span className="font-medium">Export</span>
                        </button>
                    ) : null}

                    {/* Add University Button */}
                    {addButton && addButton ? (
                        <button
                            type="button"
                            className="flex items-center space-x-2 px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg"
                            onClick={() => setShowAdd(true)}
                        >
                            <div className="w-5 h-5 flex items-center justify-center">
                                {addition}
                            </div>
                            <span className="font-medium">{addButtonText}</span>
                        </button>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default PageHeader